import { render, staticRenderFns } from "./BackgroundImage.vue?vue&type=template&id=c0ea02c2&scoped=true&lang=pug"
import script from "./BackgroundImage.vue?vue&type=script&lang=js"
export * from "./BackgroundImage.vue?vue&type=script&lang=js"
import style0 from "./BackgroundImage.vue?vue&type=style&index=0&id=c0ea02c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ea02c2",
  null
  
)

export default component.exports